import { render, staticRenderFns } from "./ResolutionQuestion.vue?vue&type=template&id=9050deca"
import script from "./ResolutionQuestion.vue?vue&type=script&lang=js"
export * from "./ResolutionQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports